import { Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ECElementEvent } from 'echarts';

@Component({
  selector: 'app-horizontal-histogram',
  templateUrl: './horizontal-histogram.component.html',
  styleUrls: ['./horizontal-histogram.component.css']
})
export class HorizontalHistogramComponent implements OnInit {
  @Input() histogramData: any;
  @Output() chartClick = new Subject<ECElementEvent>();
  @Input() barCount: number;
  @Input() barName: string;
  @Input() barName2: string;
  @Input() isMock: boolean;

  chartOption: any;
  ngOnInit() {

  }

  ngOnChanges(): void {
    if (this.histogramData?.length) {
      this._plotHistogram();
    }
  }

 

  /**
   * Determines whether chart click on
   * @param value
   */
  onChartClick(event: any) {
    if (!this.isMock) {
      this.chartClick.next(event);
    }
  }
  private _plotHistogram() {

    // Simulated data for the histogram
    const data = this.histogramData;

    // Calculate histogram bins
    const bins = this._calculateHistogramBins(data);

    this.chartOption = {
      grid: {
        left: '8%',
        right: '8%',
        bottom: '14%',
        top: '8%',
        containLabel: true
      },
      yAxis: [{
        type: 'category',
        data: bins.map(bin => bin.label), // Labels for each bin on the x-axis,
        axisLabel: {
          rotate: -60,
          fontSize: 8,
          offset: 0,
          fontWeight: 'bold'
        },
        axisTick: { show: false },
        name: this.barName,
        nameLocation: "middle",
        nameGap: 40
      }],
      xAxis: {
        type: 'value',
        name: this.barName2,
        nameLocation: "middle",
        nameGap: 60,
        axisLabel: {
          fontWeight: 'bold'
        }
      },
      series: [
        {
          name: 'Histogram',
          type: 'bar',
          barWidth: '25%',
          data: bins.map(bin => ({
            value: bin.count,
            binValues: bin.binValues, // Add the bin values to the data point
            binEntities: bin.binEntities,
            // binType: bin.binType
          })), // Count of values for each bin on the y-axis
          emphasis: {
            focus: 'series',
          },
          itemStyle: {
            color: data?.[0]?.color,
            borderRadius: [5, 5, 0, 0]
          },
          label: {
            show: true,
            position: 'right',
            fontWeight: 'bold'
          },
        },
      ],
    };
  }

  // Helper function to calculate histogram bins
  private _calculateHistogramBins(data: any[]): { label: string; count: number; range: [number, number]; binValues: any, binEntities: any }[] {
    const dataValues = data?.map(({ value }) => value);
    const max = Math.max(...dataValues);
    const min = Math.min(...dataValues);
    let binCount: any;
    if ([...new Set(dataValues)]?.length === 1) {
      binCount = 1;
    } else {
      binCount = this.barCount
    }
    // Automatically determine binCount based on the max & min of data points
    binCount = binCount === 0 ? 1 : binCount;
    const binWidth = (max - min) / binCount;

    const bins: { label: string; count: number; range: [number, number], binValues: any, binEntities: any }[] = [];

    for (let i = 0; i < binCount; i++) {
      const binStart = min + i * binWidth;
      const binEnd = binStart + binWidth;

      const label = binStart === binEnd ? `${binStart.toFixed(data?.[0]?.roundOf)}` : `${binStart.toFixed(data?.[0]?.roundOf)} - ${binEnd.toFixed(data?.[0]?.roundOf)}`;
      const count = dataValues.filter(value => value >= binStart && value <= binEnd).length;
      const binValues = dataValues.filter(value => value >= binStart && value <= binEnd);
      const binEntities = data.filter(item => item.value >= binStart && item.value <= binEnd)?.map(item => {
        item.range = label;
        return item;
      });

      bins.push({ label, count, range: [binStart, binEnd], binValues, binEntities });
    }

    return bins;
  }
}